import React, { useEffect, useState } from "react";
import { Col, Row, Button, Skeleton } from "antd";
import { useViewport } from "@bindeleddet/core/hooks";
import axios from "axios";
import { useLoginContext } from "@bindeleddet/core/contexts/login";
import { LogEntry, NoShow } from "@bindeleddet/core/types";
import { useHistory } from "react-router-dom";
import { StyledTextDiv, StyledTextDivBold } from "./style";
import MyProfileToolCard from "../../MyProfileToolCard/MyProfileToolCard";

const { Input: SkeletonInput } = Skeleton;

const StudentLogCard = () => {
  const { width } = useViewport();
  const breakpoint = 900;

  const history = useHistory();
  const [log, setLog] = useState<LogEntry[]>([]);
  const [loadingEvents, setLoadingEvents] = useState<boolean>(true);
  const [loadingWarnings, setLoadingWarnings] = useState<boolean>(true);
  const [warnings, setWarnings] = useState<NoShow[]>([]);

  const { currentUser } = useLoginContext();

  useEffect(() => {
    if (!currentUser) return;
    axios
      .get<LogEntry[]>(`/events/${currentUser?.id}/log/`)
      .then(response => {
        setLog(response.data.filter(entry => entry.time_attended));
        setLoadingEvents(false);
      })
      .catch(() => {
        setLoadingEvents(false);
      });
  }, [currentUser]);

  useEffect(() => {
    if (!currentUser) return;
    axios
      .get<NoShow[]>(`/events/student-no-shows/${currentUser?.id}/`)
      .then(response => {
        setWarnings(response.data);
        setLoadingWarnings(false);
      })
      .catch(() => {
        setLoadingWarnings(false);
      });
  }, [currentUser]);

  return (
    <MyProfileToolCard title="Min logg">
      <Row
        gutter={{
          xs: 8,
          sm: 16,
          md: 24,
          lg: 32,
        }}
      >
        <Col span={width < breakpoint ? 24 : 12}>
          <StyledTextDivBold>Tidligere arrangementer</StyledTextDivBold>
          <br />
          <StyledTextDiv>
            {loadingEvents ? <SkeletonInput /> : log?.length === 0 && "Du har ikke deltatt på tidligere arrangementer"}
            {log?.map(entry => (
              <Button
                key={entry.id}
                onClick={() => history.push(`/events/${entry.event}`)}
                type="link"
                style={{ padding: 0 }}
              >
                {new Date(entry.event_start).toLocaleDateString("no-NB")} - {entry.event_name}
                <br />
              </Button>
            ))}
          </StyledTextDiv>
        </Col>
        <Col span={width < breakpoint ? 24 : 12} style={width < breakpoint ? {} : { textAlign: "right" }}>
          <StyledTextDivBold>Advarsler</StyledTextDivBold>
          <br />
          <StyledTextDiv>
            {loadingWarnings ? <SkeletonInput /> : warnings?.length === 0 && "Du har ingen advarsler"}
            {warnings?.map(warning => (
              <div key={warning.id}>
                {new Date(warning.time).toLocaleDateString("no-NB")} - {warning.event_name} (
                {warning.no_show_type === 0 ? "Ikke deltatt" : "Brudd på retningslinjer"})
              </div>
            ))}
          </StyledTextDiv>
        </Col>
      </Row>
    </MyProfileToolCard>
  );
};

export default StudentLogCard;
